import List from "./List";
import AddEdit from "./AddEdit";

export default { List, AddEdit };
